function getFileSizeLabel(fileSizeInBytes) {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];

  let index = 0;
  while (fileSizeInBytes >= 1024 && index < units.length - 1) {
    fileSizeInBytes /= 1024;
    index++;
  }

  if (index > 0) {
    fileSizeInBytes = Math.round(fileSizeInBytes * 100) / 100;
  }

  return `${fileSizeInBytes.toFixed(2)} ${units[index]}`;
}

export default getFileSizeLabel;
